import styled from 'styled-components';

export const PicturesContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: auto;
  height: 60vh;

`;

export const Picture = styled.img`
  width: 145px;
  height: 145px;
  margin: 10px;
  object-fit: cover;
  cursor: pointer;
`;

export const BigPicture = styled.div`
  width: 150px;
  height: 150px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: auto;
    height: 100%;
    max-width: 100%;
    object-fit: contain;
  }
  &.active {
    transition: all 0.8s ease-in-out;
    width: 100%;
    height: 100%;
  }
`;
